module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierda-dcf4c137.png";